import React, { useState,useContext } from 'react'
import { Form, Input, Button, message, Row, Col } from 'antd';
import 'antd/dist/antd.css';
import { Layout } from 'antd';
import { FaUserCircle } from 'react-icons/fa';
import axios from 'axios'
import { setCookie } from '../../getDatabase';
import { AuthContext } from '../../context/AuthContext';
const { Footer } = Layout;

export default function Login() {
    const [loading, setLoading] = useState(false)

    const {setAuth} = useContext(AuthContext)

    const onFinish = async (values) => {
        setLoading(true)
        // // console.log('Success:', values.password);
        // console.log(values.username, values.password)
        const params = new URLSearchParams();
        params.append('db_user', process.env.React_App_DB_USER);
        params.append('db_password', process.env.React_App_DB_PASSWORD);
        params.append('db', process.env.React_App_DB);

        params.append('data', JSON.stringify({ username: values.username, password: values.password }));

        return await axios.post(
            `${process.env.React_App_URL}/login/loginProcess.php`, params
        )
            .then(async function (response) {
                // console.log(response?.data)
                if (response?.data === "incorrect") {
                    message.error("Username & Password មានបញ្ហា!!")
                    setLoading(false)
                } else {
                    message.success('Login ជោគជ័យ!!');
                    setCookie('u_id_report', response?.data?.u_id,1)
                    setAuth(true)
                    setLoading(false)
                }
            });
    };


    return (
        <Row
            className='login-form'
        >
            <Col xs={24} 
                style={{ padding: '20px 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}
            >
                <div style={{ width: '400px' }}>
                    <FaUserCircle className="Login-user-icon" />
                    <p
                        style={{
                            textAlign: "center",
                            fontSize: "15pt",
                            fontFamily: "Bayon",
                            marginTop: "20px",
                            color: '#1890ff'
                        }}
                    >
                        ចូលទៅកាន់ប្រព័ន្ធគ្រប់គ្រង
                    </p>

                    <Form
                        name="basic"

                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        layout="vertical"
                        style={{
                            marginTop: "50px"
                        }}
                    >
                        <Row>
                            <Col xs={24}>
                                <Form.Item
                                    label="ឈ្មោះអ្នកប្រើ"
                                    name="username"
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                >
                                    <Input size='large' style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item
                                    label="លេខសម្ងាត់"
                                    name="password"
                                    rules={[{ required: true, message: 'Please input your password!' }]}
                                >
                                    <Input.Password size='large' style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>


                            <Col xs={24}>
                                <Form.Item >
                                    <Button type="primary" htmlType="submit" size='large' style={{ width: '100%' }} loading={loading}>
                                        ចូលប្រព័ន្ធ
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Col>
            <Footer
                style={{
                    textAlign: 'center',
                    // position: "absolute",
                    // bottom: 0,
                    width: "100%",
                    // height: "10vh"
                }}
            >
                &#169; គ្រប់រូបភាព និងអត្ថបទត្រូវបានរក្សាសិទ្ធដោយ វីខេ អង្គរ
            </Footer>
        </Row>
    )
}
